@if (
  ((statusChanges$ | async) || (control()!['touched'] && errorMessageKey)) &&
  !showImmediately()
) {
  <div class="fv-plugins-message-container">
    <div class="fv-help-block">
      <ng-container *transloco="let t; prefix: 'uiKit'">
        @if (errorMessageKey) {
          <span role="alert">
            {{ t(errorMessageKey, errorMessageParams) }}
          </span>
        }
      </ng-container>
    </div>
  </div>
}

@if (((statusChanges$ | async) || errorMessageKey) && showImmediately()) {
  <div class="fv-plugins-message-container">
    <div class="fv-help-block">
      <ng-container *transloco="let t; prefix: 'uiKit'">
        @if (errorMessageKey) {
          <span role="alert">
            {{ t(errorMessageKey, errorMessageParams) }}
          </span>
        }
      </ng-container>
    </div>
  </div>
}
